import API from '../../api/API'
import Common from './common'
var api = new API();
let UrlParamHash=function(url) {
	var params = [],h;
		if(url){
			var hash = url.slice(url.indexOf("?") + 1).split('&');
			for (var i = 0; i < hash.length; i++) {
			h = hash[i].split("=");
			params[h[0]] = h[1];
		}
	}
	return params;
}

var adv = {

	bpeventadv:function(val,url){
	 	var params = UrlParamHash(url);
	 	var goods_id = params['goods_id'] ? decodeURI(params['goods_id']) : '';
	 	var store_id = params['store_id'] ? decodeURI(params['store_id']) : '';
		if(goods_id){
			val.goods_id = goods_id;
			val.direct_type = '商品详情';
		}else if(store_id){
			val.store_id = store_id;
			val.direct_type = '店铺';
		}else{
			val.direct_type = '其他';
		}
		console.log(val);
		api.post({api:Common.getSourec().extapi+'/tracking/addBpLog',param:{'evt_name':'广告点击率统计','extInfo':val}}).then(response => {
		});
	}
}

export default adv;


// WEBPACK FOOTER //
// ./src/global/js/adv.js